import { render, staticRenderFns } from "./TextFileSelector.vue?vue&type=template&id=334c9517&scoped=true&"
import script from "./TextFileSelector.vue?vue&type=script&lang=js&"
export * from "./TextFileSelector.vue?vue&type=script&lang=js&"
import style0 from "./TextFileSelector.vue?vue&type=style&index=0&id=334c9517&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334c9517",
  null
  
)

export default component.exports